import { type LanguageKey } from '@/domain/locale'
import { PREBID_CONFIG } from '@/lib/ads/constants/adSlots'
import { type GotApiResponse } from '@/lib/ads/types/adConfig'

type GotFallbackFunction = (languageKey: LanguageKey) => GotApiResponse

export const DESKTOP_SRP_GOT_FALLBACK = (languageKey: LanguageKey): GotApiResponse => ({
  sourceSnapshotId: '18864eaf-7d05-445a-ae73-61780dc39e59',
  experimentGroups: {},
  dynamicConditions: {
    lang: languageKey,
    mode: 'light',
  },
  adSettings: [
    {
      settingsId: 'a476c08b-781e-4cc6-a06b-a4f4deb95207',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-leaderboard-top',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
            ],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'top_header',
        pt: 'ResultsSearch',
        sizeMappingName: 'TOP_LEADERBOARD',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
        ],
        bids: [
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582474,
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112843,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_TOP_ENGLISH_728x90',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714691',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415741',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477244,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092774,
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_TOP_ENGLISH_BT',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190663',
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_Desktop_InFeed_Top',
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: '8c26a919-a18b-4061-ac0b-314da30ebe38',
      adType: 'afs_native',
      settings: {
        clientId: 'kijiji-ca-search2',
        numberOfAds: 8,
        numberOfRows: '2',
        subType: 'text',
        templateId: '4292467516',
      },
    },
    {
      settingsId: 'bc7e1ddf-5b69-4c20-b2a6-3961cf1a98ba',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-inline-srp_1',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
              [300, 250],
            ],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'bottom',
        pt: 'ResultsSearch',
        sizeMappingName: 'INLINE',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
          [300, 250],
        ],
        bids: [
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_desktop_inline1',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714692',
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112838,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477245,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190670',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415749',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092776,
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 14286334,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE1_ENGLISH_728x90',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582476,
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '315133',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE1_ENGLISH_BT',
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: '0124856a-5510-49eb-b59e-d2464bcd8fde',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-inline-srp_2',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
              [300, 250],
            ],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'bottom2',
        pt: 'ResultsSearch',
        sizeMappingName: 'INLINE',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
          [300, 250],
        ],
        bids: [
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112839,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_desktop_inline1',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '315134',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415767',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582478,
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 14286336,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190671',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE2_ENGLISH_BT',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE2_ENGLISH_728x90',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477246,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714693',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092780,
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: 'ee991760-629e-43de-8150-168d21fd51e0',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-inline-srp_3',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
              [300, 250],
            ],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'bottom3',
        pt: 'ResultsSearch',
        sizeMappingName: 'INLINE',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
          [300, 250],
        ],
        bids: [
          {
            bidder: 'appnexus',
            params: {
              placementId: 18317550,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112841,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_desktop_inline3',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540955328',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 18317560,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 1549838,
              zoneId: 45324,
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540955320',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: '651715',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '452978',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '452985',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE3_ENGLISH',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1549852,
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: 'e58d997f-df26-49f6-933a-7390956048a6',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-inline-srp_4',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
              [300, 250],
            ],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'bottom4',
        pt: 'ResultsSearch',
        sizeMappingName: 'INLINE',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
          [300, 250],
        ],
        bids: [
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540955321',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540955329',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 29258442,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_desktop_inline3',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1549854,
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '452986',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE4_ENGLISH',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE4_ENGLISH_BT',
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112842,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '452979',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1549840,
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 18317561,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: 'bc695d36-d034-4090-90b5-72ac817a2edd',
      adType: 'display_prebid',
      settings: {
        id: 'gpt-minileaderboard-base',
        mediaTypes: {
          banner: {
            sizes: [[575, 210]],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pt: 'ResultsSearch',
        sizeMappingName: 'MINI_LEADERBOARD',
        sizes: [[575, 210]],
        bids: [
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_Inline_Native_TextwithImage_desktop',
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: 'b3759792-38ec-461a-9f5f-c48d88a51131',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-leaderboard-base',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
              [300, 250],
              [320, 50],
            ],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'base',
        pt: 'ResultsSearch',
        sizeMappingName: 'BASE_LEADERBOARD',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
          [300, 250],
          [320, 50],
        ],
        bids: [
          {
            bidder: 'appnexus',
            params: {
              placementId: 14286339,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_Desktop_InFeed_Baseboard',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415773',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: '346263',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190672',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '315135',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714694',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_BASEBOARD_ENGLISH_728x90',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477247,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112837,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092782,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582480,
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: '76eabc79-f768-4048-85b4-2b0a3fc4efbd',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-skyscraper',
        mediaTypes: {
          banner: {
            sizes: [
              [300, 600],
              [160, 600],
              [300, 250],
            ],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'top',
        pt: 'ResultsSearch',
        sizeMappingName: 'SKYSCRAPER',
        sizes: [
          [300, 600],
          [160, 600],
          [300, 250],
        ],
        bids: [
          {
            bidder: 'appnexus',
            params: {
              placementId: 14286345,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_Desktop_InFeed_LeftRail',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '315136',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190673',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_LEFT_RAIL_ENGLISH_160x600',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_LEFT_RAIL_ENGLISH_BT',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092784,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582482,
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477248,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112840,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714696',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415785',
            },
            responsiveRules: {},
          },
        ],
      },
    },
  ],
})

const DESKTOP_ZSRP_GOT_FALLBACK = (languageKey: LanguageKey): GotApiResponse => ({
  sourceSnapshotId: '18864eaf-7d05-445a-ae73-61780dc39e59',
  experimentGroups: {},
  dynamicConditions: {
    lang: languageKey,
    mode: 'light',
  },
  adSettings: [
    {
      settingsId: '8c26a919-a18b-4061-ac0b-314da30ebe38',
      adType: 'afs_native',
      settings: {
        clientId: 'kijiji-ca-search2',
        numberOfAds: 8,
        numberOfRows: '2',
        subType: 'text',
        templateId: '4292467516',
      },
    },
    {
      settingsId: 'dd77ae16-fdb9-4ea2-b768-b92e48fd3b0a',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-leaderboard-top',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
            ],
          },
        },
        pagetype: 'zsrp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'top_header',
        pt: 'ResultsSearch',
        sizeMappingName: 'TOP_LEADERBOARD',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
        ],
        bids: [
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582474,
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112843,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_TOP_ENGLISH_728x90',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714691',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415741',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477244,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092774,
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_TOP_ENGLISH_BT',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190663',
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_Desktop_InFeed_Top',
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: '1281d22d-a580-46eb-8e29-f0000eac046b',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-leaderboard-base',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
              [300, 250],
              [320, 50],
            ],
          },
        },
        pagetype: 'zsrp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'base',
        pt: 'ResultsSearch',
        sizeMappingName: 'BASE_LEADERBOARD',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
          [300, 250],
          [320, 50],
        ],
        bids: [
          {
            bidder: 'appnexus',
            params: {
              placementId: 14286339,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_Desktop_InFeed_Baseboard',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415773',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: '346263',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190672',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '315135',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714694',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_BASEBOARD_ENGLISH_728x90',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477247,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112837,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092782,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582480,
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: '03660632-04ed-4bbe-8177-d4e19ef8807e',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-skyscraper',
        mediaTypes: {
          banner: {
            sizes: [
              [300, 600],
              [160, 600],
              [300, 250],
            ],
          },
        },
        pagetype: 'zsrp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'top',
        pt: 'ResultsSearch',
        sizeMappingName: 'SKYSCRAPER',
        sizes: [
          [300, 600],
          [160, 600],
          [300, 250],
        ],
        bids: [
          {
            bidder: 'appnexus',
            params: {
              placementId: 14286345,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_Desktop_InFeed_LeftRail',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '315136',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190673',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_LEFT_RAIL_ENGLISH_160x600',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_LEFT_RAIL_ENGLISH_BT',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092784,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582482,
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477248,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112840,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714696',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415785',
            },
            responsiveRules: {},
          },
        ],
      },
    },
  ],
})

const MWEB_SRP_GOT_FALLBACK = (languageKey: LanguageKey): GotApiResponse => ({
  sourceSnapshotId: 'f340e6c1-9674-4972-9e18-392f2d18d172',
  experimentGroups: {},
  dynamicConditions: {
    lang: languageKey,
    mode: 'light',
  },
  adSettings: [
    {
      settingsId: '112380f2-d51a-4a3a-9603-8d39dbdd047c',
      adType: 'afs_native',
      settings: {
        clientId: 'mobile-kijiji-ca-search',
        numberOfRows: '1',
        subType: 'text',
        templateId: '5174874674',
      },
    },
    {
      settingsId: 'bc7e1ddf-5b69-4c20-b2a6-3961cf1a98ba',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-inline-srp_1',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
              [300, 250],
            ],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'bottom',
        pt: 'ResultsSearch',
        sizeMappingName: 'INLINE',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
          [300, 250],
        ],
        bids: [
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_desktop_inline1',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714692',
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112838,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477245,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190670',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415749',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092776,
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 14286334,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE1_ENGLISH_728x90',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582476,
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '315133',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE1_ENGLISH_BT',
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: '0124856a-5510-49eb-b59e-d2464bcd8fde',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-inline-srp_2',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
              [300, 250],
            ],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'bottom2',
        pt: 'ResultsSearch',
        sizeMappingName: 'INLINE',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
          [300, 250],
        ],
        bids: [
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112839,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_desktop_inline1',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '315134',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415767',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582478,
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 14286336,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190671',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE2_ENGLISH_BT',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE2_ENGLISH_728x90',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477246,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714693',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092780,
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: 'ee991760-629e-43de-8150-168d21fd51e0',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-inline-srp_3',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
              [300, 250],
            ],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'bottom3',
        pt: 'ResultsSearch',
        sizeMappingName: 'INLINE',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
          [300, 250],
        ],
        bids: [
          {
            bidder: 'appnexus',
            params: {
              placementId: 18317550,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112841,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_desktop_inline3',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540955328',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 18317560,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 1549838,
              zoneId: 45324,
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540955320',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: '651715',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '452978',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '452985',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE3_ENGLISH',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1549852,
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: 'e58d997f-df26-49f6-933a-7390956048a6',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-inline-srp_4',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
              [300, 250],
            ],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'bottom4',
        pt: 'ResultsSearch',
        sizeMappingName: 'INLINE',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
          [300, 250],
        ],
        bids: [
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540955321',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540955329',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 29258442,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_desktop_inline3',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1549854,
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '452986',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE4_ENGLISH',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_INLINE4_ENGLISH_BT',
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112842,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '452979',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1549840,
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 18317561,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: 'bc695d36-d034-4090-90b5-72ac817a2edd',
      adType: 'display_prebid',
      settings: {
        id: 'gpt-minileaderboard-base',
        mediaTypes: {
          banner: {
            sizes: [[575, 210]],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pt: 'ResultsSearch',
        sizeMappingName: 'MINI_LEADERBOARD',
        sizes: [[575, 210]],
        bids: [
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_Inline_Native_TextwithImage_desktop',
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: 'b3759792-38ec-461a-9f5f-c48d88a51131',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-leaderboard-base',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
              [300, 250],
              [320, 50],
            ],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'base',
        pt: 'ResultsSearch',
        sizeMappingName: 'BASE_LEADERBOARD',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
          [300, 250],
          [320, 50],
        ],
        bids: [
          {
            bidder: 'appnexus',
            params: {
              placementId: 14286339,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_Desktop_InFeed_Baseboard',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415773',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: '346263',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190672',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '315135',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714694',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_BASEBOARD_ENGLISH_728x90',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477247,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112837,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092782,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582480,
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: 'c49fd72b-a697-4d8c-bab0-b8c6478cd911',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-sticky',
        mediaTypes: {
          banner: {
            sizes: [
              [300, 50],
              [320, 50],
            ],
          },
        },
        pagetype: 'srp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'top',
        pt: 'ResultsSearch',
        sizeMappingName: 'MOBILE_LEADERBOARD',
        sizes: [
          [300, 50],
          [320, 50],
        ],
        bids: [
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582474,
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112843,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_TOP_ENGLISH_728x90',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714691',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415741',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477244,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092774,
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_TOP_ENGLISH_BT',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190663',
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_Desktop_InFeed_Top',
            },
            responsiveRules: {},
          },
        ],
      },
    },
  ],
})

const MWEB_ZSRP_GOT_FALLBACK = (languageKey: LanguageKey): GotApiResponse => ({
  sourceSnapshotId: 'f340e6c1-9674-4972-9e18-392f2d18d172',
  experimentGroups: {},
  dynamicConditions: {
    lang: languageKey,
    mode: 'light',
  },
  adSettings: [
    {
      settingsId: 'dd77ae16-fdb9-4ea2-b768-b92e48fd3b0a',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-leaderboard-top',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
            ],
          },
        },
        pagetype: 'zsrp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'top_header',
        pt: 'ResultsSearch',
        sizeMappingName: 'TOP_LEADERBOARD',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
        ],
        bids: [
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582474,
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112843,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_TOP_ENGLISH_728x90',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714691',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415741',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477244,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092774,
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_TOP_ENGLISH_BT',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190663',
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_Desktop_InFeed_Top',
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: 'dedbefc3-d5d5-4d01-ae06-3734603b1d5d',
      adType: 'afs_native',
      settings: {
        clientId: 'partner-kijiji-ca-search2',
        numberOfAds: 8,
        numberOfRows: '2',
        subType: 'text',
        templateId: '9871685507',
      },
    },
    {
      settingsId: '1281d22d-a580-46eb-8e29-f0000eac046b',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-leaderboard-base',
        mediaTypes: {
          banner: {
            sizes: [
              [970, 250],
              [970, 90],
              [728, 90],
              [300, 250],
              [320, 50],
            ],
          },
        },
        pagetype: 'zsrp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'base',
        pt: 'ResultsSearch',
        sizeMappingName: 'BASE_LEADERBOARD',
        sizes: [
          [970, 250],
          [970, 90],
          [728, 90],
          [300, 250],
          [320, 50],
        ],
        bids: [
          {
            bidder: 'appnexus',
            params: {
              placementId: 14286339,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_Desktop_InFeed_Baseboard',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415773',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: '346263',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190672',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '315135',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714694',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_BASEBOARD_ENGLISH_728x90',
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477247,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112837,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092782,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582480,
            },
            responsiveRules: {},
          },
        ],
      },
    },
    {
      settingsId: '03660632-04ed-4bbe-8177-d4e19ef8807e',
      adType: 'display_prebid',
      settings: {
        bidderTimeout: PREBID_CONFIG.BIDDER_TIMEOUT,
        id: 'gpt-skyscraper',
        mediaTypes: {
          banner: {
            sizes: [
              [300, 600],
              [160, 600],
              [300, 250],
            ],
          },
        },
        pagetype: 'zsrp',
        path: '/5138/kij.ca.buyandsell',
        pos: 'top',
        pt: 'ResultsSearch',
        sizeMappingName: 'SKYSCRAPER',
        sizes: [
          [300, 600],
          [160, 600],
          [300, 250],
        ],
        bids: [
          {
            bidder: 'appnexus',
            params: {
              placementId: 14286345,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'triplelift',
            params: {
              inventoryCode: 'Kijiji_SearchResults_Desktop_InFeed_LeftRail',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '315136',
            },
            responsiveRules: {},
          },
          {
            bidder: 'ix',
            params: {
              siteId: '190673',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_LEFT_RAIL_ENGLISH_160x600',
            },
            responsiveRules: {},
          },
          {
            bidder: 'pubmatic',
            params: {
              publisherId: '156591',
              adSlot: 'PUBMATIC_SEARCH_RESULTS_PAGE_LEFT_RAIL_ENGLISH_BT',
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 1092784,
            },
            responsiveRules: {},
          },
          {
            bidder: 'rubicon',
            params: {
              accountId: 12230,
              siteId: 45324,
              zoneId: 582482,
            },
            responsiveRules: {},
          },
          {
            bidder: 'appnexus',
            params: {
              placementId: 10477248,
              publisherId: 821042,
            },
            responsiveRules: {},
          },
          {
            bidder: 'smartadserver',
            params: {
              formatId: 112840,
              pageId: 1599355,
              siteId: 508684,
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '538714696',
            },
            responsiveRules: {},
          },
          {
            bidder: 'openx',
            params: {
              delDomain: 'kijiji-d.openx.net',
              unit: '540415785',
            },
            responsiveRules: {},
          },
        ],
      },
    },
  ],
})

// DESKTOP/SRPS & SRPB return the same config at present
// pass params to the function to get the config for a specific page

export const GOT_FALLBACKS: Record<string, GotFallbackFunction> = {
  DESKTOP_SRPS: DESKTOP_SRP_GOT_FALLBACK,
  DESKTOP_SRPB: DESKTOP_SRP_GOT_FALLBACK,
  DESKTOP_ZSRP: DESKTOP_ZSRP_GOT_FALLBACK,
  MWEB_SRPS: MWEB_SRP_GOT_FALLBACK,
  MWEB_SRPB: MWEB_SRP_GOT_FALLBACK,
  MWEB_ZSRP: MWEB_ZSRP_GOT_FALLBACK,
}
